import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "networkCard_container" }
const _hoisted_2 = { class: "cardTitle" }
const _hoisted_3 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'networkCard',
  props: {
    channel: {
        type: String,
        default: () => ''
    },
    channelName: {
        type: String,
        default: () => ''
    },
    instructions: {
        type: String,
        default: () => ''
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.channel), 1),
      _createTextVNode(_toDisplayString(__props.channelName), 1)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "line" }, null, -1)),
    _createElementVNode("div", {
      class: "cardContent",
      innerHTML: __props.instructions
    }, null, 8, _hoisted_3)
  ]))
}
}

})